import { render, staticRenderFns } from "./weekly_goal_pill_inactive_light.svg?vue&type=template&id=2c94410e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports